import { AppStreamSDK } from "../../../../utils/AppStreamSDK";
import {
  IToolbarButtonActiveContentType,
  IToolbarButtonProps,
  IToolbarButtonType,
  NotificationList,
  ToolbarActiveStateContentProps,
  ToolbarContainerItemContent,
} from "@amzn/aws-euc-ui";
import React, { memo } from "react";
import { Header, Icon, Tabs } from "@cloudscape-design/components";
import { GeneralTabContent } from "./GeneralTabContent";
import {
  ToolbarItemId,
  ToolbarPreferenceTabId,
} from "../../../../constants/Toolbar";
import { KeyboardTabContent } from "./KeyboardTabContent";
import { useToolbarPreferenceTabIdStore } from "../../../../hooks/useToolbarPreferenceTabIdStore";
import { Trans, useTranslation } from "react-i18next";
import { usePreferenceNotificationStore } from "../../../../hooks/useNotificationStore";

export const usePreferencesToolbarItem = (
  appStreamSdk: AppStreamSDK
): IToolbarButtonProps => {
  const { t } = useTranslation();

  const activeTabId = useToolbarPreferenceTabIdStore((store) => store.activeId);
  const setActiveTabId = useToolbarPreferenceTabIdStore(
    (store) => store.setActiveId
  );
  const notificationList = usePreferenceNotificationStore(
    (store) => store.notificationList
  );

  return {
    type: IToolbarButtonType.STATEFUL,
    activeStateContentType: IToolbarButtonActiveContentType.CONTAINER,
    id: ToolbarItemId.PREFERENCES,
    label: t("toolbar.item.preference.label"),
    ariaLabel: t("toolbar.item.preference.ariaLabel"),
    icon: <Icon name="settings" />,
    ActiveStateContent: memo((props: ToolbarActiveStateContentProps) => (
      <ToolbarContainerItemContent
        close={props.close}
        closeButtonAriaLabel={t("toolbar.item.preference.close.ariaLabel")}
        closeButtonTitle={t("toolbar.item.content.close.title")}
      >
        <Header>
          <Trans i18nKey={"toolbar.item.preference.label"} />
        </Header>
        <NotificationList
          items={notificationList}
          ariaLabel={t("notification.list.ariaLabel")}
        />
        <Tabs
          onChange={({ detail }) => {
            setActiveTabId(detail.activeTabId as ToolbarPreferenceTabId);
          }}
          activeTabId={activeTabId}
          tabs={[
            {
              label: t("toolbar.item.preference.content.tab.general.label"),
              id: ToolbarPreferenceTabId.GENERAL,
              content: <GeneralTabContent appStreamSdk={appStreamSdk} />,
            },
            // TODO Camera tab (https://issues.amazon.com/issues/LOWA-8994)
            // TODO Microphone tab (https://issues.amazon.com/issues/LOWA-8995)
            {
              label: t("toolbar.item.preference.content.tab.keyboard.label"),
              id: ToolbarPreferenceTabId.KEYBOARD,
              content: <KeyboardTabContent appStreamSdk={appStreamSdk} />,
            },
          ]}
        />
      </ToolbarContainerItemContent>
    )),
  };
};
